import { Component, Input, OnInit } from '@angular/core';
import {TylGeneralMatMenuComponent} from './tyl-general-mat-menu.component';

@Component({
  selector: 'tyl-mat-menu',
  templateUrl: 'tyl-mat-menu.component.html',
  exportAs: 'menuTrigger'
})

export class TylMatMenuComponent extends TylGeneralMatMenuComponent implements OnInit {
    @Input() iconWidth: number;

    @Input() public image: string;
    @Input() public disabledImage: string;
    @Input() public label: string;
    @Input() public showLabel = true;
    @Input() public disabled = false;
    @Input() public textColor: string;
    @Input() public useLink = false;
    @Input() public showNoRowSelectedMsg = false;
}
